import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { recharge_total_rank_currency } from "@/api/dataAll/dataAll";
export default {
  name: "topupLeaderboard",
  mixins: [tabulation],
  data: function data() {
    return {
      tableHead: [],
      value2: [],
      tableData: [],
      reqLoading: false,
      Header: [],
      HeaderVND: [{
        label: this.$t('nameLabel'),
        prop: 'role_name'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('currentLevel'),
        prop: 'level'
      }, {
        label: this.$t('fightingPower'),
        prop: 'fighting'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'upMoney'
      }, {
        label: this.$t('currencyAmountUsd'),
        prop: 'upMoneyexchange'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('vipLevel'),
        prop: 'vip'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }, {
        label: this.$t('userRegisterTimeLabel'),
        prop: 'register_time'
      }, {
        label: this.$t('userTotalRechargeAmount'),
        prop: 'real_time_amount'
      }],
      HeaderUSD: [{
        label: this.$t('nameLabel'),
        prop: 'role_name'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('currentLevel'),
        prop: 'level'
      }, {
        label: this.$t('fightingPower'),
        prop: 'fighting'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'upMoney'
      }, {
        label: this.$t('currencyAmountVnd'),
        prop: 'upMoneyexchange'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('vipLevel'),
        prop: 'vip'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }, {
        label: this.$t('userRegisterTimeLabel'),
        prop: 'register_time'
      }, {
        label: this.$t('userTotalRechargeAmount'),
        prop: 'real_time_amount'
      }],
      HeaderP: [{
        label: this.$t('nameLabel'),
        prop: 'role_name'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('currentLevel'),
        prop: 'level'
      }, {
        label: this.$t('fightingPower'),
        prop: 'fighting'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('vipLevel'),
        prop: 'vip'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }, {
        label: this.$t('userRegisterTimeLabel'),
        prop: 'register_time'
      }, {
        label: this.$t('userTotalRechargeAmount'),
        prop: 'real_time_amount'
      }]
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.reqLoading = true;
                _context.next = 3;
                return _this.getexchangeRate();

              case 3:
                if (_this.queryCurrency == 'VND') {
                  _this.Header = _this.HeaderVND;
                } else if (_this.queryCurrency == 'USD') {
                  _this.Header = _this.HeaderP;
                } else {
                  _this.Header = _this.HeaderP;
                }

                recharge_total_rank_currency(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData())).then(function (res) {
                  if (res.status == 200) {
                    (function () {
                      _this.resData = res.data;
                      _this.tableHead = [];
                      var data = [];

                      var pageData = _objectSpread({}, res.data);

                      var _loop = function _loop(i) {
                        var list = [];
                        var userIds = [];
                        pageData[i].forEach(function (j, ji) {
                          if (j.role_id instanceof Array) {
                            userIds.push(j.user_id);
                            j.role_id.forEach(function (l, li) {
                              list.push({
                                user_id: j.user_id,
                                channel: j.channel,
                                role_id: j.role_id[li],
                                server_id: j.server_id[li],
                                fighting: j.fighting[li],
                                last_login_time: j.last_login_time[li],
                                //real_time_amount: j.real_time_amount[li],
                                level: j.level[li],
                                recharge_amount: j.recharge_amount[li],
                                role_name: j.role_name[li],
                                vip: j.vip[li]
                              });
                            });
                          }
                        });
                        pageData[i] = pageData[i].filter(function (obj) {
                          return !userIds.includes(obj.user_id);
                        });
                        pageData[i] = [].concat(_toConsumableArray(pageData[i]), list);
                      };

                      for (var i in pageData) {
                        _loop(i);
                      }

                      var _loop2 = function _loop2(k) {
                        pageData[k].forEach(function (i) {
                          var taskData = {};

                          _this.Header.forEach(function (j, ji) {
                            var Money = Number(k.slice(2));
                            var ks = i[j.prop];

                            if (j.prop == 'upMoney') {
                              taskData[j.prop] = _this.isyjfmvnd() ? Money : _this.$utils.conversion(Money);
                            } else if (j.prop == 'upMoneyexchange') {
                              taskData[j.prop] = _this.isyjfmvnd() ? (Money * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Money * _this.exchangeRate).toFixed(2);
                            } else if (j.prop == 'real_time_amount') {
                              taskData[j.prop] = _this.isyjfmvnd() ? i["real_time_amount"] : _this.$utils.conversion(i["real_time_amount"]);
                            } else {
                              taskData[j.prop] = ks instanceof Array ? ks.toString() : ks;
                            }

                            if (i.recharge_amount && i.recharge_amount instanceof Array) {
                              if (j.prop.indexOf('upMoney') > -1) {
                                var list = [];
                                var listexchange = [];
                                i.recharge_amount.map(function (s) {
                                  list.push(_this.isyjfmvnd() ? s : _this.$utils.conversion(s));
                                  listexchange.push(_this.isyjfmvnd() ? (Number(s) * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Number(s) * _this.exchangeRate).toFixed(2));
                                });
                                taskData[j.prop] = list.toString();
                                taskData['upMoneyexchange'] = listexchange.toString();
                              }
                            }
                          });

                          data.push(taskData);
                        });
                      };

                      for (var k in pageData) {
                        _loop2(k);
                      }

                      _this.tableData = data;
                    })();
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exportdata: function exportdata() {
      this.$export.excel({
        columns: this.Header,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};